import React from "react";
import FAQSection from "../components/FAQSection"; // <- your import
import QuoteForm from "../components/QuoteForm";

const Homepage = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="relative text-white">
        <div className="absolute inset-0 z-10 bg-gradient-to-b from-black/10 to-black/10"></div>

        {/* Desktop Image */}
        <img
          src="/crousel.webp"
          loading="lazy"
          className="hidden md:block w-full h-[800px] object-cover"
          alt="Flyash Bricks Factory exterior view"
        />

        {/* Mobile Image */}
        <img
          src="/anilbricksssss.webp"
          loading="lazy"
          className="block md:hidden w-full h-[400px] object-cover"
          alt="Flyash Bricks Mobile view"
        />

        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center text-center px-4">
          <p className="mt-4 text-xl md:text-2xl">Strong • Eco-Friendly • Durable</p>
          <a
            href="#contact"
            className="mt-6 bg-green-600 hover:bg-green-700 px-8 py-3 rounded-full shadow-lg text-white font-semibold transition transform hover:scale-105"
          >
            Get in Touch
          </a>
        </div>
      </section>

      {/* About Us */}
      <section id="about" className="py-16 px-6 md:px-20 bg-white text-center">
        <h2 className="text-3xl font-bold mb-8">About Us</h2>
        <div className="flex flex-col md:flex-row items-center gap-8">
          <img
            src="/worker-flyash-bricks.webp"
            loading="lazy"
            alt="Worker handling flyash bricks in factory"
            className="rounded-xl shadow-lg w-full md:w-1/4"
          />
          <p className="text-sm md:text-base md:w-3/4 text-left leading-relaxed text-gray-700">
  <strong>Anil Flyash Bricks</strong> is a trusted manufacturer of  
  <strong> fly ash bricks</strong> and <strong>paver blocks</strong>, 
  based in <strong>Giridih, Jharkhand</strong>. We provide durable, 
  eco-friendly, and affordable building materials used by builders and 
  developers across <strong>Dhanbad, Bokaro, Deoghar, Asansol, Durgapur, 
  and Jamtara</strong>. Our high-quality <strong>fly ash and cement </strong> 
  products ensure strength, smooth finish, and long life — while reducing 
  pollution and conserving soil.  
  <br /><br />
  We also manufacture premium <strong>paver blocks</strong> for driveways, 
  pathways, and landscaping projects — designed to blend strength with 
  modern style.  
  <br /><br />
  Choose <strong>Anil Flyash Bricks</strong> for reliable supply, 
  eco-friendly production, and sustainable construction solutions.
</p>

        </div>
      </section>

      {/* Products */}
      <section id="products" className="py-16 bg-gray-100 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-bold mb-10">Our Products</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {[
            { img: "/product1.webp", name: "Fly Ash Bricks", alt: "Stack of Fly Ash Bricks" },
            { img: "/product2.webp", name: "Blocks", alt: "Concrete Blocks" },
            { img: "/product3.webp", name: "Paver Blocks", alt: "Paver Blocks for outdoor flooring" },
            { img: "/product4.webp", name: "Tiles", alt: "Eco-friendly Tiles" },
          ].map((product) => (
            <div
              key={product.name}
              className="bg-white rounded-xl shadow-lg p-4 hover:shadow-2xl transition transform hover:-translate-y-1"
            >
              <img
                src={product.img}
                loading="lazy"
                alt={product.alt}
                className="rounded-md w-full h-50 object-contain bg-white"
              />
              <p className="mt-3 font-semibold">{product.name}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Testimonials */}
      <section id="testimonials" className="py-16 px-6 md:px-20 bg-white text-center">
        <h2 className="text-3xl font-bold mb-10">What Our Customers Say</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {[
            {
              name: "Rohit Kumar",
              text: "The quality of bricks from Anil Flyash Bricks is excellent! They are strong, uniform, and delivered on time.",
            },
            {
              name: "Priya Construction",
              text: "We’ve been purchasing regularly and are always happy with their professional service and durability.",
            },
            {
              name: "Sunil Yadav",
              text: "Affordable prices and eco-friendly production — exactly what our projects needed.",
            },
          ].map((review) => (
            <div
              key={review.name}
              className="bg-gray-100 p-6 rounded-xl shadow-md hover:shadow-xl transition"
            >
              <p className="italic text-gray-700 mb-4">“{review.text}”</p>
              <h4 className="font-semibold text-green-700">– {review.name}</h4>
            </div>
          ))}
        </div>
      </section>

      {/* Gallery */}
      <section id="gallery" className="py-16 px-6 md:px-20 bg-gray-100 text-center">
        <h2 className="text-3xl font-bold mb-10">Our Work Gallery</h2>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { src: "/factory1.webp", alt: "Factory building exterior" },
            { src: "/delivery1.webp", alt: "Truck delivering bricks" },
            { src: "/bricks-pallet.webp", alt: "Pallet stacked with bricks" },
            { src: "/construction-site.webp", alt: "Construction site using flyash bricks" },
            { src: "/factory2.webp", alt: "Workers at flyash bricks factory" },
            { src: "/truck-load.webp", alt: "Truck loaded with bricks" },
            { src: "/paver-display.webp", alt: "Display of paver blocks" },
            { src: "/team.webp", alt: "Team of workers at Anil Bricks" },
          ].map((imgObj, i) => (
            <img
              key={i}
              src={imgObj.src}
              loading="lazy"
              alt={imgObj.alt}
              className="rounded-lg shadow-lg hover:scale-105 transition-transform"
            />
          ))}
        </div>
      </section>

 {/* Franchise Opportunity Section */}
<section id="franchise" className="py-12 bg-white text-center border-t border-gray-200">
  <div className="flex flex-col md:flex-row items-center justify-center gap-8 px-6 md:px-20">
    
    {/* Text Content */}
    <div className="md:w-1/2 text-center md:text-left">
      <h2 className="text-2xl font-bold mb-4">Become a Franchise Partner</h2>
      
    </div>

    {/* Image */}
    <div className="md:w-1/2">
      <img
        src="/Franchise-image.webp"
        alt="Franchise Opportunity with Anil Flyash Bricks"
        className="rounded-xl shadow-lg w-full h-auto object-cover"
        loading="lazy"
      />
    </div>
    <p className="mb-6 text-gray-600">
        Want to start your own business with a trusted brand?  
        Grab our franchise opportunity today! Limited spots available—contact us now to learn more.
      </p>
      <a
  href="https://wa.me/919905306080?text=Hello%20Anil%20Flyash%20Bricks%20Team%2C%20I%20am%20interested%20in%20your%20franchise%20opportunity.%20My%20name%20is%20%5BYour%20Name%5D%20and%20I%20am%20located%20in%20%5BCity%2FState%5D.%20Please%20provide%20more%20details%20about%20the%20franchise%20process%20and%20requirements.%20Thank%20you!"
  target="_blank"
  rel="noopener noreferrer"
  className="bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-full font-semibold shadow-md"
>
  Contact for Franchise
</a>

    
  </div>
</section>

      {/* Blog / YouTube */}
     <section id="blog" className="py-16 px-6 md:px-20 bg-gray-100 text-center">
  <h2 className="text-3xl font-bold mb-10">From Our Blog & YouTube</h2>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

    {/* YouTube Channel Image */}
    <a
      href="https://www.youtube.com/@anilflyashbricks8582"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src="/youtube-channel-image.webp" // your YouTube banner or thumbnail
        alt="Visit Our YouTube Channel"
        className="w-full h-64 rounded-xl shadow-lg object-cover hover:scale-105 transition-transform"
      />
    </a>

    {/* Blog Preview */}
    <div className="text-left bg-white p-6 rounded-xl shadow-lg">
      <h3 className="font-bold text-xl mb-2">How Flyash Bricks Help the Environment</h3>
      <p className="text-gray-600 mb-4">
        Flyash bricks are made using industrial waste and reduce soil erosion and pollution.
        Learn how we contribute to a sustainable future.
      </p>
      <a href="/blog" className="text-green-600 font-semibold hover:underline">
        Read More →
      </a>
    </div>

  </div>
</section>
{/* ✅ Service Areas Section (newly added for SEO) */}
<section className="py-12 text-center bg-white border-t border-gray-200">
  <h2 className="text-2xl font-bold mb-4 text-green-700">Service Areas</h2>
  <p className="text-gray-700 mb-6">
    We proudly supply fly ash bricks and paver blocks across Jharkhand and West Bengal:
  </p>
  <div className="flex flex-wrap justify-center gap-3">
    {[
      { name: "Dhanbad", path: "/flyash-bricks-in-dhanbad" },
      { name: "Giridih", path: "/flyash-bricks-in-giridih" },
      { name: "Bokaro", path: "/flyash-bricks-in-bokaro" },
      { name: "Asansol", path: "/flyash-bricks-in-asansol" },
      { name: "Durgapur", path: "/flyash-bricks-in-durgapur" },
      { name: "Deoghar", path: "/flyash-bricks-in-deoghar" },
      { name: "Jamtara", path: "/flyash-bricks-in-jamtara" },
    ].map((city) => (
      <a
        key={city.name}
        href={city.path}
        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-full text-sm font-semibold shadow-md"
      >
        {city.name}
      </a>
    ))}
  </div>
</section>

      {/* FAQ Section */}
<FAQSection />

      {/* Contact */}
      <section id="contact" className="py-16 bg-gray-100 px-6 md:px-20 text-center">
        <h2 className="text-3xl font-bold mb-6">Contact Us</h2>
        <p className="mb-2">Address: Jitkundi, Near Khudisar, Giridih, Jharkhand – 825108</p>
        <p className="mb-2">Phone: +91-9905306080</p>
        <p className="mb-6">Email: info@anilbricks.com</p>
        <a
          href="https://wa.me/919905306080"
          className="mt-6 inline-block bg-green-600 hover:bg-green-700 px-8 py-3 rounded-full text-white font-semibold shadow-lg transition transform hover:scale-105"
        >
          <i className="fa-brands fa-whatsapp"></i> Chat on WhatsApp
        </a>
         {/* Google Map */}
  <div className="mt-10 w-full h-72">
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3715.438351927124!2d86.1478254!3d24.1057301!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f3f96549350245%3A0x7126aad681ca26a3!2sAnil%20Flyash%20Bricks%20Factory!5e0!3m2!1sen!2sin!4v1698339145975!5m2!1sen!2sin"
      width="100%"
      height="100%"
      style={{ border: 0 }}
      allowFullScreen=""
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
      title="Anil Flyash Bricks Factory Location"
    ></iframe>
  </div>
      </section>
<QuoteForm />
    </div>
  );
};

export default Homepage;
